import { IItem } from '~api/interfaces/IItem';
import { IProductParams, ISkuParams } from '~api/interfaces/IParams';
import { IIncludesQuery, ISkuFilterQuery } from '~api/interfaces/ISkuFilterQuery';
import { sanitizeJsonForQuery } from '~utils/ContentFormatter';
import { getProductsWithSkus } from './Filters';
import { splitItemByType } from './SplitItemByType';

interface IProductsFilter {
    product_id: IIncludesQuery;
    skus?: ISkuFilterQuery;
}

interface ISkuFilter {
    skus: ISkuFilterQuery;
}

export const buildProductQueryFilter = (
    items: IItem[],
    includeInnerHits: boolean = true
): string => {
    const {
        sku: skus,
        product: products
    }: { sku: ISkuParams[]; product: IProductParams[] } = splitItemByType(items);

    const [productIdsWithSku, productsWithSkus] = getProductsWithSkus(products);
    const filteredProducts = products.filter((product) => !productIdsWithSku.includes(product.id));
    const hasProductIdParam = filteredProducts.length > 0;
    const hasSkusIdParam = skus.length > 0;
    const skusIds = hasSkusIdParam ? skus.map(({ id }) => id) : [];

    const filters: (IProductsFilter | ISkuFilter)[] = [];
    if (hasSkusIdParam || productsWithSkus.length > 0) {
        const skusFilter: ISkuFilter = {
            skus: {
                filter: {
                    sku_id: {
                        in: [...skusIds, ...productsWithSkus]
                    }
                },
                includeInnerHits
            }
        };

        filters.push(skusFilter);
    }
    if (hasProductIdParam) {
        const productsFilter: IProductsFilter = {
            product_id: {
                in: filteredProducts.map(({ id }) => id)
            }
        };

        filters.push(productsFilter);
    }

    return sanitizeJsonForQuery(JSON.stringify(filters));
};
